import { createStore, combineReducers, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import miusuario from '../redux/reducers/miusuario'
import idioma from '../redux/reducers/idioma'
import pais from '../redux/reducers/pais'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
 
const thunkMiddleware = require('redux-thunk').default

const rootReducer = combineReducers({
    miusuario,
    pais,
    idioma
})

const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)
 
export default () => {
  let store = createStore(persistedReducer, applyMiddleware(thunkMiddleware))
  let persistor = persistStore(store)
  return { store, persistor }
}